/**
 * identityPasskey — the one callable's wire contract: three ceremonies behind
 * one `onCall`, dispatched on `action`. A product that serves two realms mounts
 * the door twice as two callables rather than widening this union.
 *
 * Each variant flattens its ceremony's own input onto this level via
 * `.extend()` — every source input is a plain strict object with no refinement
 * — so there is one schema per ceremony for the two to drift from.
 */
import { z } from 'zod';
import { PasskeyChallengeInput, PasskeyChallengeOutput } from './passkeyChallenge.action.ts';
import {
  VerifyPasskeyEnrollmentInput,
  VerifyPasskeyEnrollmentOutput,
} from './verifyPasskeyEnrollment.action.ts';
import {
  VerifyPasskeySignInInput,
  VerifyPasskeySignInOutput,
} from './verifyPasskeySignIn.action.ts';

export const IdentityPasskeyInput = z.discriminatedUnion('action', [
  PasskeyChallengeInput.extend({ action: z.literal('passkeyChallenge') }),
  VerifyPasskeyEnrollmentInput.extend({ action: z.literal('verifyPasskeyEnrollment') }),
  VerifyPasskeySignInInput.extend({ action: z.literal('verifyPasskeySignIn') }),
]);
export type IdentityPasskeyInput = z.infer<typeof IdentityPasskeyInput>;

// The three outputs share no field to discriminate on — a challenge, an empty
// ack, a token — so this stays a plain union.
export const IdentityPasskeyOutput = z.union([
  PasskeyChallengeOutput,
  VerifyPasskeyEnrollmentOutput,
  VerifyPasskeySignInOutput,
]);
export type IdentityPasskeyOutput = z.infer<typeof IdentityPasskeyOutput>;
